<template>
  <div>
    <!-- ヘッダ -->
    <comMaintHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="deptname"></comMaintHeaderAuth>
    <!-- メイン -->
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="info" elevation="2">
          問い合わせの内容を確認できます。
        </v-alert>
        <!-- 問い合わせキー情報 -->
        <v-banner single-line>
          <v-row justify="start" align-content="center" class="pb-0">
            <v-col cols="12" sm="10" md="9" lg="9" xl="9">
              <v-avatar slot="icon" color="warning" size="40">
                <v-icon icon="map-marker-alert-outline" color="white">mdi-map-marker-alert-outline</v-icon>
              </v-avatar>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col cols="6" sm="6" md="5" lg="4" xl="3" class="mt-3">
              <p>問い合わせ番号：{{ inquiryId }}</p>
            </v-col>
            <v-col cols="6" sm="6" md="5" lg="4" xl="3" class="mt-3">
              <p>問い合わせ日時：{{ dispInquiryDateTime }}</p>
            </v-col>
          </v-row>

        </v-banner>
        <!-- データ入力エリア -->
        <v-simple-table class="simple-table" >
          <template v-slot:default>
            <tbody>
              <tr v-for="item in desserts" :key="item.name" class="simple-table-tr">
                <td class="table-title" >{{ item.name }}</td>
                <td v-if="!item.switchFlg">
                  <v-sheet v-html="item.inputval" class="text-h6"></v-sheet>
                </td>
                <td v-else>
                    <v-row >
                      <v-radio-group v-model="selectedType" row>
                        <v-radio
                          v-for="(value, key) in pullMapInfo"
                          color="indigo"
                          :key="key"
                          :label="value"
                          :value="key"
                          :disabled="picked"
                        >
                        </v-radio>
                      </v-radio-group>
                    </v-row>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <!-- ボタンエリア -->

        <v-row>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center pt-0">
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn x-large color="indigo darken-1" dark min-width="200px" @click="back()">戻る</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <!-- フッター -->
    
    <!-- その他 -->
    <comMessage :msg="dlgMsgErr.msg" :isOpen="dlgMsgErr.isOpen" :doYes="dlgMsgErr.doYes"/>
  </div>
</template>

<script>
import Constants from "../common/constants";
import Utils from "../common/utils";
export default {
  name: "MainteContactUsConfirm",
  props: ["srcViewId", "requestId"],
  data() {
    return {
      username: "",
      deptname: "",
      screenTitle: " [メンテ] 問い合わせ情報確認",
      screenId: "MTQ200",
      desserts: [],
      dispInquiryDateTime : "",
      inquiryId: "",
      selectedType: "",
      pullMapInfo: null,
      returnViewUrl: "",
      picked: true,
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
      dlgMsgErr: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgErr.isOpen = false;
        },
      },
    };
  },
  created() {
    this.initialize();
  },
   beforeRouteLeave(to, from, next) {
    // 画面用データストア破棄
    if (to.name != 'MTQ100') {
      this.$store.commit("mainteInquiryListSearch/resetState");
    }
    next();
  },
  methods : {
   /*
    * 初期表示
    */
    initialize: function() {
      this.setAuthUserInfo();
      this.messageArea = this.$i18n.t('webmsg.mtQ200.area');
      this.inquiryNo = Utils.removeChar(this.$route.params.inquiryNo, '-');
      /* データ表示 */
      this.dispSearchData(this.inquiryNo);
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setMainteLoginInfoMixin();
      this.username = authInfo['username'];
      this.deptname = authInfo['deptname'];
    },
   /*
    * 「戻る」ボタン押下
    */
    back: function() {
      // 遷移元画面へ戻る
      let srcScreenId = this.$route.params['srcScreenId'];
      if (srcScreenId == null) { 
        this.$router.push(this.$router.resolve({ name: "MTQ100" }).href);
      } else {
         this.$router.push(this.$router.resolve({ name: srcScreenId }).href);
      }
    },
    /*
    * 問い合わせ情報取得・表示
    */
    dispSearchData : async function(inquiryNo) {
      
      try {
        let apiurl = Constants.getUrlApiMTQ200G01(inquiryNo);
        let accessToken = this.$store.getters["authcUser/getAccessToken"];
        // サービス呼び出し
        let response = await this.$axios.get(apiurl,
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken},
              responseType: "json",
            }); 
        // 問い合わせ情報表示
        this.dispSearchResultData(response.data);
      } catch(error) {
          this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm100', ['問い合わせ内容']);
          this.dlgMsgErr.isOpen = true;
          this.desserts.push({});
      }
      return;
    },
    /*
    * 画面表示用データの生成(問い合わせ情報)
    */
    dispSearchResultData: function(apiResponseData) {
      if (apiResponseData == null) {
        return;
      }
      let responseDto = apiResponseData.data;

      this.inquiryId = responseDto.displayInquiryNo;
      this.dispInquiryDateTime = responseDto.inquiryDatetime;

      this.desserts.push({ name: "氏名（フリガナ）", inputval: responseDto.nameKana, txtAreaFlg: false, switchFlg: false })
      this.desserts.push({ name: "氏名", inputval: responseDto.name, txtAreaFlg: false, switchFlg: false })
      this.desserts.push({ name: "会社名（フリガナ）", inputval: responseDto.companyNameKana, txtAreaFlg: false, switchFlg: false })
      this.desserts.push({ name: "会社名", inputval: responseDto.companyName, txtAreaFlg: false, switchFlg: false })
      this.desserts.push({ name: "電話番号", inputval: responseDto.phoneNo, txtAreaFlg: false, switchFlg: false })
      this.desserts.push({ name: "メールアドレス", inputval: responseDto.mailAddress, txtAreaFlg: false, switchFlg: false })
      // 問い合わせ種類
      this.pullMapInfo = responseDto.inquiryTypeMap;
      this.desserts.push({ name: "問い合わせ種類", inputval: "", placeholderChrs: "", requiredFlg: true, txtAreaFlg: false, switchFlg: true })
      this.selectedType = responseDto.inquiryType;

      this.desserts.push({ name: "問い合わせ内容", inputval: Utils.nl2br(responseDto.detail), txtAreaFlg: true, switchFlg: false })

      
    },
  //  /*
  //   * URL取得
  //   * @param viewId:画面ID
  //   * @return URL
  //   */
  //   getSrcViewUrl(viewId) {
  //     let retVal = "";
  //     // メニューマスタ取得
  //     let menuMstist = this.$store.getters["master/getMenuMstist"];
  //     if (menuMstist == null) {
  //       return retVal;
  //     }
  //     // 引数の画面IDに紐づくメニュー情報取得
  //     let routerName = "";
  //     let searchArry = menuMstist.find((v) => v.id === viewId);
  //     if (searchArry != null) {
  //       routerName = searchArry.routerName;
  //     } else {
  //       return retVal;
  //     }
  //     // ルータ情報検索
  //     retVal = this.$router.resolve({ name: routerName }).href;
  //     return retVal;
  //   },
  },
};
</script>

<style scoped>
.simple-table {
  table-layout: auto;
  width: 96%;
  margin: 40px 20px;
  border: 1px solid #9E9E9E;
}
.simple-table-tr:hover {
  background: transparent !important;
}

.table-title {
  background-color: #f2f2f2;
  width: 20%;
  font-size: 0.9em !important;
  text-align: left;
}
.table-title-required {
  background-color: #f2f2f2;
  width: 10%;
  text-align: right;
}
.table-td-1 {
  display: flex;
  text-align: left;
  padding: 6px 6px !important;
  background-color: #f2f2f2;
}
.table-td-2 {
  text-align: left;
  padding: 6px 6px !important;
  background-color: #f2f2f2;
  height: auto;
}

@media screen and (max-width: 750px) {
  .simple-table {
    table-layout: auto;
    width: 96%;
    margin: 5px 5px;
  }
  .table-title {
    background-color: #f2f2f2;
    width: 34%;
    font-size: 0.9em !important;
    text-align: left;
  }
  .table-title-required {
    background-color: #f2f2f2;
    width: 20%;
    text-align: right;
  }
}

</style>